export default "__VITE_ASSET__Dv6sFtrL__"